// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  PackageCheck,
  ScanLine,
  ScanSearch,
  Tags,
} from "lucide-react";
import {
  getPublishedFacts,
  getPublishedSolutions,
  localize,
} from "../content/repository.js";
import { useI18n } from "../i18n/I18nContext.jsx";
import { Seo, schemaBuilders } from "../seo/Seo.jsx";
import { SeamlessLoopVideo } from "../components/SeamlessLoopVideo.jsx";
import { ArrowIcon } from "../components/VisualIcon.jsx";

const homeCopy = {
  ru: {
    seoTitle: "Инженерные системы для производства",
    seoDescription:
      "ANLEXX объединяет маркировку, этикетирование, упаковку, машинное зрение, автоматизацию и сервис в единую производственную систему.",
    eyebrow: "Инженерный центр ANLEXX · Узбекистан",
    heroA: "Производство",
    heroB: "как единая",
    heroC: "система.",
    intro:
      "Маркировка, этикетирование, упаковка, машинное зрение и автоматизация — в одном инженерном контуре: от анализа задачи до запуска и сервиса.",
    start: "Обсудить задачу",
    explore: "Смотреть решения",
    quickKicker: "С чего начнём",
    quickTitle: "Какую задачу нужно решить на линии?",
    principle: "Инженерный подход",
    principleTitle: "Сильная линия начинается с точного понимания задачи.",
    principleText:
      "Изучаем продукт, упаковку, скорость и условия производства. Затем выбираем технологию, проверяем конфигурацию и интегрируем решение в действующую линию.",
    engineeringCenterCta: "Как работает инженерный центр",
    solutions: "Решения ANLEXX",
    solutionsTitle: "Для каждой задачи — своё инженерное решение.",
    systemKicker: "Единый контур",
    systemTitle: "Оборудование, данные и сервис работают вместе.",
    systemText:
      "Мы связываем технологию, механику линии, программный контур и контроль результата в одну управляемую систему.",
    softwareKicker: "Программный контур",
    softwareTitle: "Tracora связывает маркировку с производственными данными.",
    softwareText:
      "Платформа поддерживает управление маркировкой, сериализацией и агрегацией. Совместимость подтверждается для конкретной версии, конфигурации и интерфейса.",
    softwareCta: "Подробнее о Tracora",
    softwareFlow: [
      "Получение кодов",
      "Печать на линии",
      "Проверка",
      "Агрегация",
    ],
    softwareStatus: "Контур производственных данных",
    softwareSignals: ["ДАННЫЕ", "ЛИНИЯ", "ТРЕКИНГ"],
    service: "Сервисный контур",
    serviceTitle: "После запуска работа только начинается.",
    serviceText:
      "Обращения принимаются 24/7. Инженер регистрирует задачу, проводит первичную диагностику и согласовывает дальнейший маршрут. Сроки выезда и ремонта определяются отдельно.",
    serviceCta: "Перейти в сервис",
    process: "Инженерный центр",
    processTitle: "От производственной задачи — к работающей системе.",
    applicationsKicker: "Области применения",
    applicationsTitle: "Решение настраивается под реальный продукт и линию.",
    applicationsText:
      "Отрасль задаёт контекст. Итоговая конфигурация определяется после анализа образцов, скорости, производственной среды и требований к прослеживаемости.",
    finalKicker: "Новый проект",
    finalTitle: "Покажите задачу. Мы определим инженерный маршрут.",
    finalText:
      "Передайте исходные данные о продукте и линии. После первичной оценки мы предложим обоснованный следующий шаг.",
    finalCta: "Передать задачу инженеру",
    finalCall: "Позвонить инженеру",
    finalHotline: "Приём инженерных обращений 24/7",
    heroMedia: "Обязательная маркировка и проверка кодов на производственной линии",
    aboutMedia: "Инженер контролирует производственную линию",
    solutionsMedia: "Упаковочная линия производит готовые короба",
    serviceMedia: "Инженер контролирует работу упаковочной линии",
    processMedia: "Инженеры проводят диагностику перед запуском линии",
    finalMedia: "Производственная линия ANLEXX",
    ticker: "МАРКИРОВКА · ЭТИКЕТИРОВАНИЕ · УПАКОВКА · ИНТЕГРАЦИЯ · СЕРВИС ·",
    quickTasks: [
      [
        "Нанести код или обязательную маркировку",
        "/solutions/industrial-marking-traceability",
      ],
      ["Автоматизировать нанесение этикетки", "/solutions/automatic-labeling"],
      ["Упаковать готовый продукт", "/solutions/product-packaging"],
      [
        "Контролировать качество на линии",
        "/solutions/machine-vision-quality-control",
      ],
      ["Связать оборудование и данные", "/software/tracora"],
    ],
    systemFlow: [
      "Задача производства",
      "Выбор технологии",
      "Оборудование и ПО",
      "Интеграция с линией",
      "Проверка результата",
      "Сервис",
    ],
    processItems: [
      [
        "01",
        "Аудит",
        "От производственной задачи — к работающей системе.",
        "Начинаем с продукта, упаковки, скорости линии, производственной среды и требуемого результата.",
        "Понятная задача и границы проекта",
        "Инженер фиксирует исходные данные и определяет, какая проверка нужна дальше.",
      ],
      [
        "02",
        "Проектирование",
        "Проектируем систему, а не набор отдельных машин.",
        "Определяем технологию, состав оборудования, точки интеграции и критерии приёмки.",
        "Обоснованная конфигурация",
        "Каждый компонент получает понятную роль в общем производственном контуре.",
      ],
      [
        "03",
        "Интеграция",
        "Оборудование, сигналы и данные работают согласованно.",
        "Связываем механику, датчики, управление и программную часть с реальным процессом предприятия.",
        "Единый контур управления",
        "Система понимает состояние линии и выполняет согласованную последовательность операций.",
      ],
      [
        "04",
        "Запуск",
        "Запускаем и проверяем результат на производстве.",
        "Настраиваем систему, проверяем сценарии и передаём решение по согласованным критериям.",
        "Работающая производственная система",
        "Пользователи получают настроенное решение и необходимые материалы для эксплуатации.",
      ],
      [
        "05",
        "Сервис",
        "Инженерная ответственность продолжается после запуска.",
        "Регистрируем обращения, проводим диагностику и согласовываем удалённую помощь или выезд.",
        "Понятный сервисный маршрут",
        "Обращения принимаются круглосуточно, дальнейшие действия определяются после оценки.",
      ],
    ],
    servicePoints: [
      "Регистрация задачи",
      "Первичная диагностика",
      "Согласование действий",
      "Инженерное сопровождение",
    ],
    applicationAreas: [
      "Продукты питания",
      "Напитки",
      "Молочная продукция",
      "Фармацевтика и БАД",
      "Косметика и гигиена",
      "Строительные материалы",
    ],
  },
  uz: {
    seoTitle: "Ishlab chiqarish uchun muhandislik tizimlari",
    seoDescription:
      "ANLEXX markirovka, etiketkalash, qadoqlash, mashinaviy ko‘rish, avtomatlashtirish va servisni yagona ishlab chiqarish tizimiga birlashtiradi.",
    eyebrow: "ANLEXX muhandislik markazi · O‘zbekiston",
    heroA: "Ishlab chiqarish",
    heroB: "yagona",
    heroC: "tizimda.",
    intro:
      "Markirovka, etiketkalash, qadoqlash, mashinaviy ko‘rish va avtomatlashtirish — vazifani tahlil qilishdan ishga tushirish va servisgacha yagona muhandislik konturida.",
    start: "Vazifani muhokama qilish",
    explore: "Yechimlarni ko‘rish",
    quickKicker: "Nimadan boshlaymiz",
    quickTitle: "Liniyada qaysi vazifani hal qilish kerak?",
    principle: "Muhandislik yondashuvi",
    principleTitle: "Kuchli liniya vazifani aniq tushunishdan boshlanadi.",
    principleText:
      "Mahsulot, qadoq, tezlik va ishlab chiqarish sharoitlarini o‘rganamiz. So‘ng texnologiyani tanlaymiz, konfiguratsiyani tekshiramiz va yechimni amaldagi liniyaga integratsiya qilamiz.",
    engineeringCenterCta: "Muhandislik markazi qanday ishlaydi",
    solutions: "ANLEXX yechimlari",
    solutionsTitle: "Har bir vazifa uchun alohida muhandislik yechimi.",
    systemKicker: "Yagona kontur",
    systemTitle: "Uskuna, ma’lumotlar va servis birgalikda ishlaydi.",
    systemText:
      "Texnologiya, liniya mexanikasi, dasturiy kontur va natija nazoratini yagona boshqariladigan tizimga birlashtiramiz.",
    softwareKicker: "Dasturiy kontur",
    softwareTitle:
      "Tracora markirovkani ishlab chiqarish ma’lumotlari bilan bog‘laydi.",
    softwareText:
      "Platforma markirovka, serializatsiya va agregatsiyani boshqarishni qo‘llab-quvvatlaydi. Moslik aniq versiya, konfiguratsiya va interfeys uchun tasdiqlanadi.",
    softwareCta: "Tracora haqida batafsil",
    softwareFlow: [
      "Kodlarni olish",
      "Liniyada bosma",
      "Tekshirish",
      "Agregatsiya",
    ],
    softwareStatus: "Ishlab chiqarish ma’lumotlari konturi",
    softwareSignals: ["MA’LUMOT", "LINIYA", "KUZATUV"],
    service: "Servis konturi",
    serviceTitle: "Ishga tushirish — ishning boshlanishi.",
    serviceText:
      "Murojaatlar 24/7 qabul qilinadi. Muhandis vazifani ro‘yxatdan o‘tkazadi, dastlabki diagnostikani bajaradi va keyingi harakatlarni kelishadi. Tashrif va ta’mirlash muddatlari alohida belgilanadi.",
    serviceCta: "Servis bo‘limiga o‘tish",
    process: "Muhandislik markazi",
    processTitle: "Ishlab chiqarish vazifasidan ishlaydigan tizimgacha.",
    applicationsKicker: "Qo‘llash sohalari",
    applicationsTitle: "Yechim real mahsulot va liniyaga moslanadi.",
    applicationsText:
      "Soha umumiy sharoitni belgilaydi. Yakuniy konfiguratsiya namunalar, tezlik, ishlab chiqarish muhiti va kuzatuvchanlik talablaridan keyin aniqlanadi.",
    finalKicker: "Yangi loyiha",
    finalTitle: "Vazifani ko‘rsating. Biz muhandislik yo‘lini belgilaymiz.",
    finalText:
      "Mahsulot va liniya bo‘yicha boshlang‘ich ma’lumotlarni yuboring. Dastlabki baholashdan keyin asoslangan keyingi qadamni taklif qilamiz.",
    finalCta: "Vazifani muhandisga yuborish",
    finalCall: "Muhandisga qo‘ng‘iroq qilish",
    finalHotline: "Muhandislik murojaatlari 24/7 qabul qilinadi",
    heroMedia: "Ishlab chiqarish liniyasida majburiy markirovka va kodlarni tekshirish",
    aboutMedia: "Muhandis ishlab chiqarish liniyasini nazorat qilmoqda",
    solutionsMedia: "Qadoqlash liniyasi tayyor qutilarni ishlab chiqarmoqda",
    serviceMedia: "Muhandis qadoqlash liniyasining ishini nazorat qilmoqda",
    processMedia: "Muhandislar liniyani ishga tushirishdan oldin diagnostika o‘tkazmoqda",
    finalMedia: "ANLEXX ishlab chiqarish liniyasi",
    ticker: "MARKIROVKA · ETIKETKALASH · QADOQLASH · INTEGRATSIYA · SERVIS ·",
    quickTasks: [
      [
        "Kod yoki majburiy markirovka qo‘yish",
        "/solutions/industrial-marking-traceability",
      ],
      ["Etiketka qo‘yishni avtomatlashtirish", "/solutions/automatic-labeling"],
      ["Tayyor mahsulotni qadoqlash", "/solutions/product-packaging"],
      [
        "Liniyada sifatni nazorat qilish",
        "/solutions/machine-vision-quality-control",
      ],
      ["Uskuna va ma’lumotlarni bog‘lash", "/engineering-center"],
    ],
    systemFlow: [
      "Ishlab chiqarish vazifasi",
      "Texnologiyani tanlash",
      "Uskuna va dasturiy ta’minot",
      "Liniyaga integratsiya",
      "Natijani tekshirish",
      "Servis",
    ],
    processItems: [
      [
        "01",
        "Audit",
        "Ishlab chiqarish vazifasidan ishlaydigan tizimgacha.",
        "Mahsulot, qadoq, liniya tezligi, ishlab chiqarish muhiti va kerakli natijadan boshlaymiz.",
        "Aniq vazifa va loyiha chegaralari",
        "Muhandis boshlang‘ich ma’lumotlarni qayd etadi va keyingi tekshiruvni belgilaydi.",
      ],
      [
        "02",
        "Loyihalash",
        "Alohida uskunalar to‘plamini emas, yaxlit tizimni loyihalaymiz.",
        "Texnologiya, uskunalar tarkibi, integratsiya nuqtalari va qabul mezonlarini belgilaymiz.",
        "Asoslangan konfiguratsiya",
        "Har bir komponent umumiy ishlab chiqarish konturida aniq vazifaga ega bo‘ladi.",
      ],
      [
        "03",
        "Integratsiya",
        "Uskuna, signallar va ma’lumotlar kelishilgan holda ishlaydi.",
        "Mexanika, sensorlar, boshqaruv va dasturiy qismni korxonaning real jarayoni bilan bog‘laymiz.",
        "Yagona boshqaruv konturi",
        "Tizim liniya holatini tushunadi va kelishilgan operatsiyalar ketma-ketligini bajaradi.",
      ],
      [
        "04",
        "Ishga tushirish",
        "Tizimni ishlab chiqarishda ishga tushiramiz va natijani tekshiramiz.",
        "Sozlaymiz, ish ssenariylarini tekshiramiz va yechimni kelishilgan mezonlar bo‘yicha topshiramiz.",
        "Ishlaydigan ishlab chiqarish tizimi",
        "Foydalanuvchilar sozlangan yechim va ekspluatatsiya uchun kerakli materiallarni oladi.",
      ],
      [
        "05",
        "Servis",
        "Muhandislik mas’uliyati ishga tushirishdan keyin ham davom etadi.",
        "Murojaatlarni ro‘yxatga olamiz, diagnostika qilamiz va masofaviy yordam yoki tashrifni kelishamiz.",
        "Tushunarli servis yo‘li",
        "Murojaatlar tunu kun qabul qilinadi, keyingi harakatlar baholashdan so‘ng belgilanadi.",
      ],
    ],
    servicePoints: [
      "Vazifani ro‘yxatdan o‘tkazish",
      "Dastlabki diagnostika",
      "Harakatlarni kelishish",
      "Muhandislik kuzatuvi",
    ],
    applicationAreas: [
      "Oziq-ovqat mahsulotlari",
      "Ichimliklar",
      "Sut mahsulotlari",
      "Farmatsevtika va BFQ",
      "Kosmetika va gigiyena",
      "Qurilish materiallari",
    ],
  },
  en: {
    seoTitle: "Engineering systems for production",
    seoDescription:
      "ANLEXX connects marking, labeling, packaging, machine vision, automation and service into one production system.",
    eyebrow: "ANLEXX engineering center · Uzbekistan",
    heroA: "Production",
    heroB: "as one",
    heroC: "system.",
    intro:
      "Marking, labeling, packaging, machine vision and automation in one engineering workflow — from task analysis to commissioning and service.",
    start: "Discuss the task",
    explore: "Explore solutions",
    quickKicker: "Where to begin",
    quickTitle: "What needs to be solved on your line?",
    principle: "Engineering approach",
    principleTitle:
      "A strong line starts with a precise understanding of the task.",
    principleText:
      "We study the product, packaging, speed and production environment. Then we select the technology, verify the configuration and integrate the solution into the operating line.",
    engineeringCenterCta: "How the engineering center works",
    solutions: "ANLEXX solutions",
    solutionsTitle: "A dedicated engineering solution for every task.",
    systemKicker: "One system",
    systemTitle: "Equipment, data and service work together.",
    systemText:
      "We connect technology, line mechanics, software and result verification into one manageable production system.",
    softwareKicker: "Software layer",
    softwareTitle: "Tracora connects marking with production data.",
    softwareText:
      "The platform supports marking, serialization and aggregation management. Compatibility is confirmed for a specific version, configuration and interface.",
    softwareCta: "Learn about Tracora",
    softwareFlow: [
      "Receive codes",
      "Line printing",
      "Verification",
      "Aggregation",
    ],
    softwareStatus: "Production data workflow",
    softwareSignals: ["DATA", "LINE", "TRACE"],
    service: "Service lifecycle",
    serviceTitle: "Commissioning is only the beginning.",
    serviceText:
      "Requests are accepted 24/7. An engineer registers the task, performs initial diagnostics and agrees the next steps. Site visits and repair timelines are confirmed separately.",
    serviceCta: "Open service",
    process: "Engineering center",
    processTitle: "From a production task to an operating system.",
    applicationsKicker: "Applications",
    applicationsTitle:
      "The solution is configured for the actual product and line.",
    applicationsText:
      "The industry provides context. The final configuration follows analysis of samples, speed, production environment and traceability requirements.",
    finalKicker: "New project",
    finalTitle: "Show us the task. We will define the engineering route.",
    finalText:
      "Send the initial product and line data. After an initial assessment, we will propose a reasoned next step.",
    finalCta: "Send the task to an engineer",
    finalCall: "Call an engineer",
    finalHotline: "Engineering requests accepted 24/7",
    heroMedia: "Mandatory marking and code verification on a production line",
    aboutMedia: "An engineer monitors the production line",
    solutionsMedia: "A packaging line produces finished cartons",
    serviceMedia: "An engineer monitors the packaging line",
    processMedia: "Engineers perform diagnostics before line commissioning",
    finalMedia: "ANLEXX production line",
    ticker: "MARKING · LABELING · PACKAGING · INTEGRATION · SERVICE ·",
    quickTasks: [
      [
        "Apply a code or mandatory marking",
        "/solutions/industrial-marking-traceability",
      ],
      ["Automate label application", "/solutions/automatic-labeling"],
      ["Package the finished product", "/solutions/product-packaging"],
      [
        "Inspect quality on the line",
        "/solutions/machine-vision-quality-control",
      ],
      ["Connect equipment and data", "/engineering-center"],
    ],
    systemFlow: [
      "Production task",
      "Technology selection",
      "Equipment and software",
      "Line integration",
      "Result verification",
      "Service",
    ],
    processItems: [
      [
        "01",
        "Audit",
        "From a production task to an operating system.",
        "We begin with the product, packaging, line speed, production environment and required outcome.",
        "A clear task and project boundaries",
        "The engineer records the inputs and determines which verification is needed next.",
      ],
      [
        "02",
        "Engineering",
        "We design a system, not a collection of separate machines.",
        "We define the technology, equipment scope, integration points and acceptance criteria.",
        "A justified configuration",
        "Every component receives a clear role in the overall production circuit.",
      ],
      [
        "03",
        "Integration",
        "Equipment, signals and data operate in coordination.",
        "We connect mechanics, sensors, control and software to the plant’s real process.",
        "A unified control circuit",
        "The system understands the line state and follows the agreed sequence of operations.",
      ],
      [
        "04",
        "Commissioning",
        "We commission the system and verify the result in production.",
        "We configure the system, test operating scenarios and hand it over against agreed criteria.",
        "An operating production system",
        "Users receive a configured solution and the agreed operating materials.",
      ],
      [
        "05",
        "Service",
        "Engineering responsibility continues after commissioning.",
        "We register requests, perform diagnostics and agree remote assistance or a site visit.",
        "A clear service route",
        "Requests are accepted around the clock; the next action is defined after assessment.",
      ],
    ],
    servicePoints: [
      "Task registration",
      "Initial diagnostics",
      "Action plan approval",
      "Engineering support",
    ],
    applicationAreas: [
      "Food products",
      "Beverages",
      "Dairy products",
      "Pharmaceuticals and supplements",
      "Cosmetics and hygiene",
      "Building materials",
    ],
  },
};

const solutionIcons = [ScanLine, ScanSearch, Tags, PackageCheck, ScanSearch];

export function HomePage() {
  const { locale } = useI18n();
  const t = homeCopy[locale];
  const [activeProcessIndex, setActiveProcessIndex] = useState(0);
  const activeProcess = t.processItems[activeProcessIndex] || t.processItems[0];
  const facts = getPublishedFacts();
  const solutions = getPublishedSolutions();
  useEffect(() => {
    const scenes = [...document.querySelectorAll(".scene-section")];
    document.documentElement.classList.add("cinema-ready");
    if (!("IntersectionObserver" in window)) {
      scenes.forEach((scene) => scene.classList.add("is-scene-visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (entry.isIntersecting)
            entry.target.classList.add("is-scene-visible");
        }),
      { threshold: 0.12, rootMargin: "8% 0px -8% 0px" },
    );
    scenes.forEach((scene) => observer.observe(scene));
    return () => {
      observer.disconnect();
      document.documentElement.classList.remove("cinema-ready");
    };
  }, []);
  return (
    <>
      <Seo
        title={t.seoTitle}
        description={t.seoDescription}
        schema={schemaBuilders.organization()}
      />
      <main>
        <section
          className="hero-v3 scene-section"
          data-hero-media-lock="v1"
          data-home-block="01"
        >
          <video
            className="hero-production-video"
            autoPlay
            muted
            loop
            playsInline
            poster="/images/anlexx-marking-hero-poster.jpg?v=0715-clean-cut"
            aria-label={t.heroMedia}
          >
            <source
              src="/videos/anlexx-marking-hero.mp4?v=0715-clean-cut"
              type="video/mp4"
            />
          </video>
          <div className="hero-video-noise" />
          <div className="hero-shade" />
          <div className="shell hero-v3-inner">
            <div className="hero-v3-copy">
              <div className="micro">
                <i />
                {t.eyebrow}
              </div>
              <h1>
                <span>{t.heroA}</span>
                <span>{t.heroB}</span>
                <em>{t.heroC}</em>
              </h1>
              <p>{t.intro}</p>
              <div className="hero-actions">
                <Link
                  className="button primary"
                  to="/contacts?type=engineering"
                >
                  {t.start}
                  <ArrowIcon />
                </Link>
                <Link className="button line" to="/solutions">
                  {t.explore}
                </Link>
              </div>
              <div className="hero-live-note">
                <i />
                <span>ANLEXX ENGINEERING</span>
                <b>MARKING · INTEGRATION · SERVICE</b>
              </div>
            </div>
          </div>
          <div className="shell stats-v3">
            {facts.slice(0, 3).map((fact) => (
              <div key={fact.id}>
                <strong>
                  {fact.id === "fact-founded"
                    ? "2018"
                    : fact.id === "fact-service-intake"
                      ? "24/7"
                      : "ANLEXX"}
                </strong>
                <span>{localize(fact.publicText, locale)}</span>
              </div>
            ))}
          </div>
        </section>
        <div className="ticker">
          <div>
            {t.ticker}
          </div>
        </div>
        <section
          className="engineering-cinema scene-section"
          data-home-block="07"
          data-home-feature="engineering-cinema"
        >
          <div className="engineering-cinema-media">
            <SeamlessLoopVideo
              src="/videos/anlexx-process-diagnostics-v2.mp4?v=0716-diagnostics-final"
              poster="/images/anlexx-process-diagnostics-v2.png"
              label={t.processMedia}
            />
            <div className="engineering-cinema-grade" />
          </div>
          <div className="shell engineering-cinema-shell">
            <div className="engineering-cinema-topline">
              <span>ANLEXX ENGINEERING SEQUENCE</span>
              <span><i /> {t.process}</span>
            </div>
            <div className="engineering-cinema-main" aria-live="polite">
              <div className="engineering-cinema-copy">
                <div className="engineering-cinema-label">
                  <strong>{activeProcess[0]}</strong>
                  <span>{activeProcess[1]}</span>
                </div>
                <h2>{activeProcess[2]}</h2>
                <p>{activeProcess[3]}</p>
              </div>
              <div className="engineering-cinema-result">
                <span>{locale === "ru" ? "Результат этапа" : locale === "uz" ? "Bosqich natijasi" : "Stage outcome"}</span>
                <h3>{activeProcess[4]}</h3>
                <p>{activeProcess[5]}</p>
              </div>
            </div>
            <div className="engineering-cinema-steps" role="group" aria-label={t.processTitle}>
              {t.processItems.map((item, index) => (
                <button
                  type="button"
                  className={index === activeProcessIndex ? "is-active" : ""}
                  aria-pressed={index === activeProcessIndex}
                  onClick={() => setActiveProcessIndex(index)}
                  key={item[0]}
                >
                  <span>{item[0]}</span>
                  <b>{item[1]}</b>
                </button>
              ))}
            </div>
          </div>
        </section>
        <section className="home-architecture tone-light" data-home-block="02">
          <div className="shell">
            <div className="home-architecture-heading">
              <span>{t.quickKicker}</span>
              <h2>{t.quickTitle}</h2>
            </div>
            <div className="home-task-grid">
              {t.quickTasks.map(([label, path], index) => (
                <Link to={path} key={label}>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <b>{label}</b>
                  <ArrowIcon />
                </Link>
              ))}
            </div>
          </div>
        </section>
        <section
          className="manifesto cinema-section about-cinema scene-section"
          id="about"
          data-home-block="03"
        >
          <div className="section-cinema-bg">
            <SeamlessLoopVideo
              src="/videos/anlexx-about-premium-v3.mp4?v=0716-premium-final"
              poster="/images/anlexx-about-premium-v3.png"
              label={t.aboutMedia}
            />
            <div className="section-cinema-grade" />
          </div>
          <div className="shell manifesto-grid">
            <div className="kicker light">{t.principle}</div>
            <div>
              <h2>{t.principleTitle}</h2>
              <p>{t.principleText}</p>
              <Link className="inline-route" to="/engineering-center">
                {t.engineeringCenterCta} <ArrowIcon />
              </Link>
            </div>
          </div>
        </section>
        <section
          className="capabilities cinema-section solutions-cinema scene-section"
          id="solutions"
          data-home-block="04"
        >
          <div className="section-cinema-bg">
            <SeamlessLoopVideo
              src="/videos/anlexx-solutions-v2.mp4?v=0716-uzbek-final"
              poster="/images/anlexx-solutions-poster-v1.png"
              label={t.solutionsMedia}
            />
            <div className="section-cinema-grade" />
          </div>
          <div className="shell">
            <div className="section-top">
              <div>
                <div className="kicker light">{t.solutions}</div>
                <h2>{t.solutionsTitle}</h2>
              </div>
            </div>
            <div className="cap-grid">
              {solutions.map((solution, index) => {
                const Icon = solutionIcons[index] || ScanLine;
                return (
                  <Link
                    to={`/solutions/${solution.slug}`}
                    className="cap-card"
                    key={solution.id}
                  >
                    <span>0{index + 1}</span>
                    <span className="icon-badge" aria-hidden="true">
                      <Icon strokeWidth={1.65} />
                    </span>
                    <div>
                      <h3>{localize(solution.title, locale)}</h3>
                      <p>{localize(solution.summary, locale)}</p>
                    </div>
                    <ArrowIcon />
                  </Link>
                );
              })}
            </div>
          </div>
        </section>
        <section className="home-architecture home-system" data-home-block="05">
          <div className="shell">
            <div className="home-architecture-heading">
              <span>{t.systemKicker}</span>
              <h2>{t.systemTitle}</h2>
              <p>{t.systemText}</p>
            </div>
            <div className="home-system-flow" role="list" aria-label={t.systemTitle}>
              {t.systemFlow.map((item, index) => (
                <div
                  key={item}
                  role="listitem"
                  style={{ "--flow-index": index }}
                >
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <b>{item}</b>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="home-architecture tone-light" data-home-block="06">
          <div className="shell home-software-layout">
            <div className="home-software-copy">
              <div className="home-architecture-heading">
                <span>{t.softwareKicker}</span>
                <h2>{t.softwareTitle}</h2>
                <p>{t.softwareText}</p>
              </div>
              <Link className="button line dark-line" to="/software/tracora">
                {t.softwareCta} <ArrowIcon />
              </Link>
            </div>
            <div className="home-software-console">
              <div className="home-software-console-head">
                <i />
                <span>TRACORA</span>
                <b>{t.softwareStatus}</b>
              </div>
              <div
                className="home-software-flow"
                role="list"
                aria-label={t.softwareStatus}
              >
                {t.softwareFlow.map((item, index) => (
                  <div key={item} role="listitem">
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    <strong>{item}</strong>
                    <i aria-hidden="true" />
                  </div>
                ))}
              </div>
              <div className="home-software-console-foot">
                {t.softwareSignals.map((item) => (
                  <span key={item}>{item}</span>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section
          className="service-v3 scene-section"
          id="service"
          data-home-block="08"
        >
          <div className="service-cinema">
            <SeamlessLoopVideo
              src="/videos/anlexx-service-monitor-v3.mp4?v=0716-monitor-final"
              poster="/images/anlexx-service-monitor-v3.png"
              label={t.serviceMedia}
            />
            <div className="service-cinema-grade" />
            <div className="service-cinema-noise" />
          </div>
          <div className="shell service-v3-grid">
            <div className="service-proof">
              <strong>24 / 7</strong>
              <span>{t.service}</span>
            </div>
            <div className="service-v3-copy">
              <div className="kicker light">{t.service}</div>
              <h2>{t.serviceTitle}</h2>
              <p>{t.serviceText}</p>
              <div className="service-points" role="list" aria-label={t.serviceTitle}>
                {t.servicePoints.map((item, index) => {
                  return (
                    <div key={item} role="listitem">
                      <span>0{index + 1}</span>
                      <b>{item}</b>
                    </div>
                  );
                })}
              </div>
              <Link className="text-cta" to="/service">
                {t.serviceCta} <ArrowIcon />
              </Link>
            </div>
          </div>
        </section>
        <section className="home-architecture tone-light" data-home-block="09">
          <div className="shell">
            <div className="home-architecture-heading">
              <span>{t.applicationsKicker}</span>
              <h2>{t.applicationsTitle}</h2>
              <p>{t.applicationsText}</p>
            </div>
            <div className="home-application-grid">
              {t.applicationAreas.map((item) => (
                <Link to={`/contacts?type=engineering&industry=${encodeURIComponent(item)}`} key={item}>
                  {item}
                  <ArrowIcon />
                </Link>
              ))}
            </div>
          </div>
        </section>
        <section className="home-final-cta scene-section" data-home-block="12">
          <div className="home-final-cinema" aria-hidden="true">
            <SeamlessLoopVideo
              src="/videos/anlexx-home-final-line-v1.mp4?v=0721-final"
              poster="/images/anlexx-home-production-scene-v1.png"
              label={t.finalMedia}
            />
            <div className="home-final-cinema-grade" />
          </div>
          <div className="shell home-final-grid">
            <div className="home-final-title">
              <span>{t.finalKicker}</span>
              <h2>{t.finalTitle}</h2>
            </div>
            <div className="home-final-action">
              <p>{t.finalText}</p>
              <Link
                className="home-final-project"
                to="/contacts?type=engineering"
              >
                <span>{t.finalCta}</span>
                <ArrowIcon />
              </Link>
              <a className="home-final-phone" href="tel:+998973447857">
                <small>{t.finalHotline}</small>
                <strong>+998 97 344 78 57</strong>
                <b>
                  {t.finalCall} <ArrowIcon />
                </b>
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
